<template>
  <Row type="flex" align="middle">
    <Col>
      <Input
        :size="size"
        v-model="email"
        type="email"
        style="width: 280px; margin-right: 8px;"
        placeholder="Enter your email"
        icon="email"
        enter-button="true"
        clearable
        element-id="email-list-signup-input"
        @on-enter="submitEmail">
      </Input>
    </Col>
    <!-- This is the margin on Input. Adding it here so this content is aligned with the input next to it -->
    <Col span="4" style="margin-bottom: 0px;">
      <Button @click="submitEmail" type="default">Join Email List</Button>
    </Col>
  </Row>
</template>
<script>
import axios from 'axios';
import { Notice } from 'iview';

export default {
  props: {
    size: { type: String, default: 'default' },
  },
  data() {
    return {
      email: null,
    };
  },
  methods: {
    formValid() {
      const vm = this;

      if (!vm.email || vm.email === '') {
        return false;
      }

      return true;
    },
    submitEmail() {
      const vm = this;

      if (!vm.formValid()) {
        Notice.error({
          title: 'Invalid Email',
          content: 'Please enter a valid email',
        });

        return false;
      }

      const portalId = '5143395';
      const formGuid = '333b37b6-ef50-4748-bc15-882273f6ff07';
      const destinationUrl = `https://api.hsforms.com/submissions/v3/integration/submit/${portalId}/${formGuid}`;
      const now = Date.now();
      const data = {
        submittedAt: now,
        fields: [
          { name: 'email', value: vm.email },
        ],
        context: {
          hutk: window.__hsUserToken, // Must have Hubspot cookie loaded
          // ipAddress: ,
          pageName: vm.$route.fullPath,
          pageUri: window.location.href,
          // skipValidation: ,
        // },
        // legalConsentOptions: {
        //   consent: ,
        },
      };

      return axios.post(destinationUrl, data)
        .then(() => {
          vm.email = null;
          Notice.success({ title: 'Thanks for joining our email list!' });
        })
        .catch((err) => {
          const responseData = err && err.response && err.response.data;
          const hubspotErrorResponse =
            (responseData && responseData.errors && responseData.errors.length) ?
            responseData.errors[0] :
            false;

          let title = 'Failed to join email list';
          let description = 'There was a problem adding you to our email list. Please try again later.';
          let duration = 0;

          if (hubspotErrorResponse.errorType === 'INVALID_EMAIL') {
            title = 'Please provide a valid email';
            description = undefined;
            duration = 4.5;
          }

          Notice.error({
            title,
            desc: description,
            duration,
          });
        })
        .finally(() => {
          vm.loading = false;
        });
    },
  },
};
</script>
<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/EmailListSignupForm.vue